import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Storage } from '@ionic/storage-angular';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  
  constructor(private storage: Storage, private router: Router) {
    this.storage.create();
  }

  async canActivate() {
    if (localStorage.getItem('isUserLoggedIn') == 'true') {
      return true;
    } else {
      this.router.navigateByUrl('/login');
    }
    return true;
  }
}
